import type { Region, RegionProfile } from './types';
import { REGION_PROFILES } from './profiles';

/**
 * 从打包时注入的环境变量读取当前区域。
 * 发布系统只需设置 APP_REGION=cn|global，其余参数由此处映射推导。
 * 开发时默认使用 cn（可在 .env.local 中设置 VITE_APP_REGION=global）。
 */
function detectRegion(): Region {
  const raw = (import.meta as { env?: { VITE_APP_REGION?: string } }).env
    ?.VITE_APP_REGION;
  if (raw === 'global') return 'global';
  return 'cn';
}

const _profile: RegionProfile = REGION_PROFILES[detectRegion()];

/** 获取当前区域配置（只读，整个应用生命周期内固定） */
export function getRegionProfile(): RegionProfile {
  return _profile;
}

export type { Region, RegionProfile };
export { REGION_PROFILES };
